import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=f424c67c&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=ts&"
export * from "./OfferCard.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=f424c67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f424c67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f424c67c')) {
      api.createRecord('f424c67c', component.options)
    } else {
      api.reload('f424c67c', component.options)
    }
    module.hot.accept("./OfferCard.vue?vue&type=template&id=f424c67c&scoped=true&", function () {
      api.rerender('f424c67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OfferCard.vue"
export default component.exports